import { gql } from '@apollo/client'

export const TRACK_AUTOMATION_STATUS = gql`
  subscription trackAutomation($projectId: String!) {
    trackAutomation(projectId: $projectId) {
      status
      automationId
      fillingPageIndex
      currentModule
      errors {
        code
        message
        step
        detailsMessage
        fatal
        module
      }
    }
  }
`
